import { render, staticRenderFns } from "./ListadoDetallesSolicitudesInscripciones.vue?vue&type=template&id=da04113e"
import script from "./ListadoDetallesSolicitudesInscripciones.vue?vue&type=script&lang=js"
export * from "./ListadoDetallesSolicitudesInscripciones.vue?vue&type=script&lang=js"
import style0 from "./ListadoDetallesSolicitudesInscripciones.vue?vue&type=style&index=0&id=da04113e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports